/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Environment values for Freewheel ad calls
 * Used in site section ID (csid) construction for ad targeting.
 * Determined by embed type (EmbedType.DESKTOP/MOBILE_WEB vs EmbedType.HTML5).
 *
 * @example
 * // Used in AbstractFreewheelClass.getSectionValuesForWeb():
 * const sectionValues = [
 *   this.getBusinessDivision(),
 *   this.getPartner(),
 *   FreewheelEnvironment.WEB,  // ← For web platforms
 *   this.getStreamType()
 * ];
 *
 * @example
 * // Used in AbstractFreewheelClass.getSectionValuesForHtml5():
 * const sectionValues = [
 *   this.getBusinessDivision(),
 *   FreewheelEnvironment.CTV,  // ← For HTML5/CTV devices
 *   this.getSystemDevice()
 * ];
 *
 * @see {@link AbstractFreewheelClass.createSiteSectionId}
 */
export enum FreewheelEnvironment {
	/**
	 * @description Web environment (Desktop and Mobile Web browsers)
	 * Used for EmbedType.DESKTOP and EmbedType.MOBILE_WEB
	 */
	WEB = 'web',

	/**
	 * @description Connected TV environment (Smart TVs, streaming devices)
	 * Used for EmbedType.HTML5 (Roku, Fire TV, Apple TV, etc.)
	 */
	CTV = 'ctv',
}